module.exports = __webpack_public_path__ + "img/delete_icon.8d9d5819.svg";